<template>
  <div class="management-layout">
    <AwlHeader />
    <router-view class="page" />
    <Sidebar class="bg-white shadow d-md-none d-flex flex-column">
      <div class="menu-items-wrapper flex-grow-1 justify-content-between d-flex flex-column">

        <!-- Company Selection -->
        <div class="company-selection-wrapper p-4 border-bottom" v-if="showContextSelect">
          <h4 class="small text-muted text-uppercase text-left w-100">
            Entra nel contesto aziendale
          </h4>

          <CompanyContextSelect
            v-model="$appState.context"
            :companies="$oauth2.me.companies"
            @input="onCompanySelect"
          />
        </div>

        <!-- Router Links -->
        <div class="menu-links flex-grow-1 pt-4">
          <ul class="pt-4 pl-0 d-inline-block">
            <li v-if="isAdmin">
              <router-link
                class="pl-4 pr-5 py-3 d-block"
                :active="$route.name === 'investors-list'"
                :to="{ name: 'investors' }"
                v-close-menu
              >Investitori</router-link>
            </li>
            <li v-if="isAdmin">
              <router-link
                class="pl-4 pr-5 py-3 d-block"
                :active="$route.name === 'consultants-list'"
                :to="{ name: 'consultants' }"
                v-close-menu
              >Supervisors</router-link>
            </li>
            <li v-if="isConsultant || isAdmin">
              <router-link
                class="pl-4 pr-5 py-3 d-block"
                :active="$route.name === 'companies-list'"
                :to="{ name: 'companies' }"
                v-close-menu
              >Aziende</router-link>
            </li>
            <!-- <li v-if="isAdmin">
              <router-link class="pl-4 pr-5 py-3 d-block" :active="$route.name === 'settings'" :to="{ name: 'settings' }" v-close-menu>
                Impostazioni
              </router-link>
            </li> -->
          </ul>
        </div>
      </div>
      <ProfileSection />
    </Sidebar>
  </div>
</template>

<script>

import closeMenuDirective from '../../../../libs/Sidebar/directives/closeMenu';
import sidebarControlMixin from '../../../../libs/Sidebar/mixins/sidebarControl';

export default {
  mixins: [sidebarControlMixin],
  components: {
    AwlHeader: () => import('./Header'),
    Sidebar: () => import('../../../../libs/Sidebar/components/Sidebar'),
    CompanyContextSelect: () => import('../../Account/CompanyContextSelect'),
    ProfileSection: () => import('../ProfileSection/ProfileSection'),
  },
  directives: {
    closeMenu: closeMenuDirective,
  },
  data () {
    return {
      collapseProfileSection: true,
      user: null,
    };
  },
  computed: {
    isAdmin () {
      return !!this.$oauth2?.me?.admin;
    },
    isConsultant () {
      return !!this.$oauth2?.me?.consultant;
    },
    myName () {
      return this.$oauth2?.me?.name;
    },
    showContextSelect () {
      return this.$oauth2.me && (this.$oauth2.me.companies?.length || 0) > 1;
    },
  },
  methods: {
    onCompanySelect () {
      this.closeSidebar();
    },
    toggleProfileSection () {
      this.collapseProfileSection = !this.collapseProfileSection;
    },
    beforeEnter (el) {
      el.style.height = '0';
    },
    enter (el) {
      el.style.height = el.scrollHeight + 'px';
    },
    beforeLeave (el) {
      el.style.height = el.scrollHeight + 'px';
    },
    leave (el) {
      el.style.height = '0';
    },
    logout () {
      this.$router.push({ name: 'logout' });
    },
    async profile () {
      try {
        const res = await this.$api.getMyProfile();
        this.user = res.data;
        this.$refs['profile-modal'].show();
      } catch (error) {
        this.$refs['error-modal'].show();
      }
    },
    changePassword () {
      this.$refs['change-password-modal'].show();
    },
  },
};

</script>

<style lang="scss">

.management-layout {
  .page {
    flex-grow: 1;
    padding-top: 60px;
    position: relative;

    &--v-center {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .profile-section {
    position: absolute;
    bottom: 0;

    &:not(.collapsed) {
      box-shadow: 0px -3px 18px 3px rgba(0,0,0,.18);
    }

    .profile-section-content {
      transition: 150ms ease-out;
    }

    .menu-items-list {
      flex-grow: 1;
      list-style-type: none;
      padding: 0;
      margin: 0;
    }

    .icon {
      align-items: flex-end;
      color: $sidebar-items-text-color;
      display: inline-flex;
      justify-content: flex-start;
      width: 24px;
    }
  }

  .menu-links {
    ul {
      list-style: none;
      min-width: 35%;
    }

    li {
      a {
        border-bottom-right-radius: 100px;
        border-top-right-radius: 100px;
        text-decoration: none;

        &.router-link-active {
          background: $primary;
          color: $white;
        }
      }
    }
  }
}

</style>
